import { styled } from "@mui/material"
import UIIcon from "../UIIcon"

export const SBPIcon = styled(UIIcon)({
  margin: "auto auto 0 auto",
})
